import { z } from 'zod';

/** Client-generated UUID — the local-first identity for a synced record. */
export const uuid = z.string().uuid();

/** Machine-readable error envelope returned by every API error (spec 00). */
export const errorEnvelope = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
});
export type ErrorEnvelope = z.infer<typeof errorEnvelope>;

export const errorCode = z.enum([
  'invalid_credentials',
  'not_entitled',
  'rate_limited',
  'validation_failed',
  'not_found',
  'conflict',
  'internal',
]);
export type ErrorCode = z.infer<typeof errorCode>;
